import axios from 'axios'
import { BUSCAR_VEICULOS } from '../types'
import { SLOW_REQUEST_CONFIG } from '../../util/loadingUtil'
import { URL } from '../../util/ambienteActions';

export default function buscarVeiculo (codigoEmpresa, pagina, registrosPorPagina, filtros, seSimples) {
  let url = `${URL}/veiculo/empresa/${codigoEmpresa}/veiculos?`;
  if (registrosPorPagina && pagina) {
    url = `${url}size=${registrosPorPagina}&from=${pagina}`
  }
  if (filtros && filtros.nome) {
    url = `${url}&nome=${filtros.nome}`
  }

  if(seSimples){
      url = `${url}&simples=true`
  }

  return dispatch => axios.get(url, SLOW_REQUEST_CONFIG).then(
      response => dispatch({
        type: BUSCAR_VEICULOS,
        payload: response

      })
  );
}